// v3.1 sections 6, 11.1–11.5. Kept separate from pending field-requiredness.
export const PUSH_LOCK_MINUTES = 60;
export const PUSH_EXEMPT_REASONS = ['Storage or hold cleared', 'LFD / per diem risk'];
export const SAME_DAY_LFD_REASONS = ['New customer request', 'Storage or hold cleared'];
interface RuleInput {
  type: string; reason: string; urgency: string; keyTier: string;
  date: string; lfd: string; asap: boolean; for: string; availableAt?: number;
}
export function evaluateCapacityRules(input: RuleInput, now: number) {
  const timingUnknown = input.type === 'Push' && (input.availableAt === undefined || !Number.isFinite(input.availableAt));
  const elapsedMinutes = timingUnknown || input.availableAt === undefined ? null : Math.max(0, (now - input.availableAt) / 60000);
  const remainingMinutes = elapsedMinutes === null ? null : Math.max(0, Math.ceil(PUSH_LOCK_MINUTES - elapsedMinutes));
  const pushInsideWindow = input.type === 'Push' && remainingMinutes !== null && remainingMinutes > 0;
  const pushBlocked = (pushInsideWindow || timingUnknown) && !PUSH_EXEMPT_REASONS.includes(input.reason);
  const sameDayLfd = input.for !== 'Bobtail' && !input.asap && !!input.date && input.date === input.lfd;
  const lfdBlocked = sameDayLfd && !SAME_DAY_LFD_REASONS.includes(input.reason);
  const tier = input.keyTier.toLowerCase().replace(/[^a-z0-9]/g, '');
  const keyCritical = ['1', '2', 'key1', 'key2'].includes(tier) && input.urgency === 'Critical';
  return { timingUnknown, elapsedMinutes, remainingMinutes, pushInsideWindow, pushBlocked, sameDayLfd, lfdBlocked, keyCritical, needsVetting: pushBlocked || lfdBlocked || keyCritical };
}
export type CapacityRuleResult = ReturnType<typeof evaluateCapacityRules>;
export function validVetting(manager: string, justification: string, managers: string[] = []) {
  return managers.includes(manager) && justification.trim().length >= 10;
}
